import BaseNoEditModules from '@src/slide/application/no-edit/entry/base/base';
import { IDCConfig } from '@src/slide/application/no-edit/common/no-edit-ark-extensions/interface';
import NoEditArkLoader from '@src/slide/application/no-edit/common/no-edit-ark-extensions';
import {
    READ_RECORD_EXTENSION_CONFIG,
} from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/read-record/component-config';
import {
    FILE_INFO_EXTENSION_CONFIG,
} from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/file-info/component-config';
import {
    DOC_SIZE_EXTENSION_CONFIG,
} from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/doc-size/component-config';
import {
    COMMON_LOADER_CONFIG,
} from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/common-loader/component-config';
import { PluginConfig } from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { READ_RECORD_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/read-record/plugin-config';
import { FILE_INFO_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/file-info/plugin-config';
import { EXIT_DOCUMENT_PLUGIN_CONFIG } from '@src/slide/application/no-edit/plugins/exit-document/plugin-config';
import {
    IBaseEditorExtensionCallBackAdapter,
} from '@src/slide/application/service/edit-extension/core/editor/base/interface';
import { IFileInfoPlugin } from '@src/slide/application/no-edit/plugins/file-info/file-info-plugin.interface';
import {
    IExitDocumentPlugin,
} from '@src/slide/application/no-edit/plugins/exit-document/exit-document-plugin.interface';

export default class NoEditModules extends BaseNoEditModules {
    protected getRegisterPlugins(): PluginConfig[] {
        return [
            READ_RECORD_PLUGIN_CONFIG,
            FILE_INFO_PLUGIN_CONFIG,
            EXIT_DOCUMENT_PLUGIN_CONFIG,
            ...super.getRegisterPlugins(),
        ];
    }

    protected getCallbackAdapter(): IBaseEditorExtensionCallBackAdapter {
        return {
            ...super.getCallbackAdapter(),
            onFileInfoClick: async () => {
                const plugin = await this.noEditService.getPlugin<IFileInfoPlugin>(FILE_INFO_PLUGIN_CONFIG.name);
                plugin?.show();
            },
            exitCurrentDocument: async () => {
                // eslint-disable-next-line max-len
                const plugin = await this.noEditService.getPlugin<IExitDocumentPlugin>(EXIT_DOCUMENT_PLUGIN_CONFIG.name);
                plugin?.exitCurrentDocument();
            },
        };
    }

    protected getArkDCConfigs(): IDCConfig[] {
        return [
            READ_RECORD_EXTENSION_CONFIG,
            FILE_INFO_EXTENSION_CONFIG,
            DOC_SIZE_EXTENSION_CONFIG,
            COMMON_LOADER_CONFIG,
        ];
    }

    // 编辑器生命周期回调
    protected onReady() {
        super.onReady();
        NoEditArkLoader.init(this.getArkDCConfigs());  // 初始化非编辑ark组件
    }
}
